import { useCsAttribute } from "./useCsAttribute";
import { useCsValue } from "./useCsValue";
const UNIT_OPTIONS_DEFAULTS = { mode: "symbol" };
/**
 * Use unit for current attribute
 *
 * Precedence
 * - unit name translation
 * - unit symbol
 * - unit id
 *
 * @category Hooks
 * @returns
 */
export function useConfigurationAttributeUnit(options = UNIT_OPTIONS_DEFAULTS) {
    const { mode = "symbol" } = options;
    const { unitId, unitSymbol, unitName } = useCsAttribute();
    if (!unitId) {
        return null;
    }
    if (mode === "symbol") {
        return unitSymbol || unitId;
    }
    return unitName || unitId;
}
/**
 * Use unit for current value
 *
 * Precedence
 * - unit name translation
 * - unit symbol
 * - unit id
 *
 * @category Hooks
 * @returns
 */
export function useConfigurationValueUnit(options = UNIT_OPTIONS_DEFAULTS) {
    const { mode = "symbol" } = options;
    const attribute = useCsAttribute();
    const value = useCsValue();
    const unitId = value.unitId || attribute.unitId;
    const unitSymbol = value.unitSymbol || attribute.unitSymbol;
    const unitName = value.unitName || attribute.unitName;
    if (mode === "symbol") {
        return unitSymbol || unitId;
    }
    return unitName || unitId;
}
/**
 * Use unit for current attribute's editable value
 *
 * Precedence
 * - unit name translation
 * - unit symbol
 * - unit id
 *
 * @category Hooks
 * @returns
 */
export function useConfigurationAttributeEditableUnit(options = UNIT_OPTIONS_DEFAULTS) {
    var _a;
    const { mode = "symbol" } = options;
    const attribute = useCsAttribute();
    // take unit id from selected value or from attribute
    const value = (_a = attribute.values) === null || _a === void 0 ? void 0 : _a.filter((v) => v.isSelected)[0];
    const unitId = (value === null || value === void 0 ? void 0 : value.unitId) || attribute.unitId;
    const unitSymbol = (value === null || value === void 0 ? void 0 : value.unitSymbol) || attribute.unitSymbol;
    const unitName = (value === null || value === void 0 ? void 0 : value.unitName) || attribute.unitName;
    if (mode === "symbol") {
        return unitSymbol || unitId;
    }
    return unitName || unitId;
}
//# sourceMappingURL=useConfigurationUnit.js.map